// analiticsApi.ts

import axios from '../api/axiosSetup3';

const analiticsPost = async (
    tenantId: string, 
    mode: string, 
    userId: number, 
    payload: object,
): Promise<boolean> => {
    const res = await axios.post(`/rpc/sf_frontend_analitics_post`, {
        p_tenant_id: tenantId,
        p_mode: mode,
        p_user_id: userId,
        p_payload: payload,
    }, {
        headers: {
            'Content-Profile': 'public' // schema
        }        
    });
    return res.status == 204;
}

export const api = {
    analiticsPost
}